import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CreditNoteForm from '../components/CreditNoteForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { generalPublicDetails } from '../../../utils/generalPublicDetails';
import { useCreateCreditNoteHandler } from '../dataHandlers/createCreditNoteHandler';

export default function CreateCreditNotePage() {
  useDocumentTitle('Credit Notes Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state.document;

  const onCreditNoteCreated = ({ payload }) => {
    if (payload.status === 'draft') {
      navigate('/drafts?tab=credit-notes');
    } else {
      navigate('/documents?tab=credit-notes');
    }
  };

  const { onSubmit, error } = useCreateCreditNoteHandler({ onSuccess: onCreditNoteCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
      billed_to: data?.billed_to || {},
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
      billed_to: data.billed_to ? data.billed_to : generalPublicDetails,
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/documents?tab=credit-notes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <CreditNoteForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
        isDraftButtonEnabled={location.state?.isDraftButtonEnabled}
      />
    </Stack>
  );
}
